<script lang="ts">
  // TODO: Convert to chart.js svelte 5
  // import { Bar } from "svelte-chartjs"

  import {
    Chart,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  } from "chart.js"

  let props = $props()
  let { dataset = [] } = props

  let delayed

  const data = {
    labels: ["Brand Purpose", "Values", "Vision", "Top 3 Goals"],

    datasets: [
      {
        label: "% Aligned",
        data: dataset,
        backgroundColor: [
          "rgba(255, 134,159,0.4)",
          "rgba(255, 134,159,0.4)",
          "rgba(255, 134,159,0.4)",
          "rgba(255, 134,159,0.4)"
        ],
        borderWidth: 2,
        borderColor: [
          "rgba(255, 134, 159, 1)",
          "rgba(255, 134, 159, 1)",
          "rgba(255, 134, 159, 1)",
          "rgba(255, 134, 159, 1)"
        ]
      }
    ]
  }

  const options = {
    animation: {
      onComplete: () => {
        delayed = true
      },
      delay: (context) => {
        let delay = 0
        if (context.type === "data" && context.mode === "default" && !delayed) {
          delay = context.dataIndex * 300 + context.datasetIndex * 100
        }
        return delay
      }
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20
        },
        title: {
          display: true,
          text: "% Aligned"
        }
      }
    },
    responsive: true
  }
  Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  let chart
  window.addEventListener("beforeprint", async () => {
    if (!chart) {
      return
    }
    chart.resize(600, 600)
  })
  window.addEventListener("afterprint", () => {
    if (!chart) {
      return
    }
    chart.resize()
  })
</script>

<!-- <Bar {data} {options} bind:chart /> -->
